import numeral from "numeral";
import "numeral/locales/ru";

numeral.locale("ru");

export const numberFormat = (num: number, format: string = "0,0") => {
  return numeral(num).format(format);
};
